export default {
  data() {
    return {
      isShowModalUpdateTable: false,
      isModalUpdateTableOpen: false,
    };
  },

  methods: {
    openModalUpdateTable(data) {
      this.isModalUpdateTableOpen = true;
      data.$touch();
      if (!data.$invalid) {
        this.isShowModalUpdateTable = true;

        setTimeout(() => {
          const el = document.getElementById('modalUpdateTableId');
          if (el) el.classList.add('show');
        }, 300);
      }
    },

    closeModalUpdateTable() {
      this.isModalUpdateTableOpen = false;
      const el = document.getElementById('modalUpdateTableId');
      if (el) el.classList.remove('show');

      setTimeout(() => {
        this.isShowModalUpdateTable = false;
      }, 200);
    },
  },
};



// WEBPACK FOOTER //
// ./src/mixins/jMixModalUpdateTable.js